module.exports = __webpack_public_path__ + "static/media/2_1.82aec2ae.png";